// AutoGenerated
export class CalismaModel {
    tarihBaslangic!: Date;
    tarihBitis!: Date;
    icerik!: string;
    sezonModelId!: string;
    altSezonModelId!: string | null;
    etkinlikKonserMi!: boolean;
    kadroIdList!: string[];
    sesGrupIdList!: string[];
    koroModelId!: string;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}